/**
 * Handle variant select.
 */

const variantSelect = function () {
  const $mainSelect = $('.js-product-main-select');
  const $options = $('.js-variant-select');

  if (!$mainSelect.length) {
    return;
  }

  $options.each(function (index, el) {
    const $option = $(this);

    $option.on('change', function () {
      const $this = $(this);
      const $checkedOptions = $(
        '.js-variant-select:checked, .js-variant-select option:selected'
      );

      const valueString = $.map($checkedOptions, function (option) {
        return option.id;
      })
        .join(' / ')
        .toLowerCase();


        $mainSelect
        .find('option')
        .filter(function (index) {
          const $this = $(this);
          const text = $this.text().toLowerCase();
          const match = text.localeCompare(valueString) === 0;
          return match;
        })
        .prop('selected', true);

      $mainSelect.trigger('change');
    });
  });

  const $colorSelect = $('.js-variant-select-color');
  const $colorName = $('.js-color-name');

  if ( $colorSelect.length && $colorName.length ) {
    $colorSelect.on('change', function() {
      const value = $(this).attr('id');

      $colorName.text(value);
    })
  }


  const $productImagesSlider = $('.js-product-slider');
  const $addToCartBtn = $('.js-add-to-cart');

  // Change data
  $mainSelect.on('change', function () {
    const $this = $(this);
    const $selectedOption = $this.find('option:selected');
    const isAvailable = $selectedOption.data('available');
    const variantID = $selectedOption.attr('value');

    // Change main image
    if ($productImagesSlider.length) {
      const featuredSlideIndex = $productImagesSlider.find(`img[data-variants="${variantID}"]`).closest('.slick-slide').data('slick-index');


      if ( featuredSlideIndex >= 0 ) {
        $productImagesSlider.slick('slickGoTo', featuredSlideIndex);
      }
    }

    if ($addToCartBtn.length) {
      if (!isAvailable && !$addToCartBtn.hasClass('btn--disabled')) {
        const text = $addToCartBtn.data('sold-out-text');

        $addToCartBtn.prop('disabled', 'disabled');
        $addToCartBtn.addClass('btn--disabled');
        $addToCartBtn.text(text);
      } else if (isAvailable && $addToCartBtn.hasClass('btn--disabled')) {
        const text = $addToCartBtn.data('available-text');

        $addToCartBtn.removeProp('disabled');
        $addToCartBtn.removeClass('btn--disabled');
        $addToCartBtn.text(text);
      }
    }
  });
};

variantSelect();
